import { restaurantPropTypes } from '@nandosaus/prop-types';
import PropTypes from 'prop-types';

import { Alert } from '../../alert';
import { Box } from '../../grid';
import { orderErrorPropTypes } from '../../../prop-types/order-error';
import { PeriPerksAlert } from '../peri-perks-cta';

const CartAlert = ({ errors, hasNetworkError, restaurant, isSignedIn, isGuestOrderingAvailable, mb, ...rest }) => {
  const validRestaurantSelected = !!restaurant;

  if (hasNetworkError) {
    return (
      <Box mx="24px" mb={mb} {...rest}>
        <Alert type="error">Network Error </Alert>
      </Box>
    );
  }

  if (errors.length > 0) {
    return errors.map(error => (
      <Box key={error.id} mx="24px" mb={mb} {...rest}>
        <Alert heading={error.heading} type="error">
          {error.message}
        </Alert>
      </Box>
    ));
  }

  if (validRestaurantSelected && !isSignedIn && !isGuestOrderingAvailable) {
    return (
      <Box mx="24px" mb={mb} {...rest}>
        <PeriPerksAlert />
      </Box>
    );
  }

  return null;
};

CartAlert.propTypes = {
  errors: PropTypes.arrayOf(orderErrorPropTypes).isRequired,
  hasNetworkError: PropTypes.bool,
  isSignedIn: PropTypes.bool,
  isGuestOrderingAvailable: PropTypes.bool,
  restaurant: restaurantPropTypes,
  mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CartAlert.defaultProps = {
  hasNetworkError: false,
  isSignedIn: true,
  restaurant: null,
  isGuestOrderingAvailable: false,
  mb: '1rem',
};

export { CartAlert };
